import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import cn from 'classnames'

import { numSpaces } from '../../utils/functions'
import CoolCats from '../../api/contract'

import { SocialLinks } from '../../components/SocialLinks/SocialLinks'

import { ReactComponent as Logo } from '../../assets/icons/logo.svg'
import { ReactComponent as Tron } from '../../assets/icons/tron.svg'
import { ReactComponent as UK } from '../../assets/icons/uk.svg'
import { ReactComponent as CN } from '../../assets/icons/cn.svg'
import { ReactComponent as SK } from '../../assets/icons/sk.svg'

import './Header.scss'

const getPreffix = () => {
  const split = window.location.hostname.split('.')
  switch (split[0]) {
    case 'cn':
      return 1

    case 'kr':
      return 2
  
    default:
      return 0
  }
}

export const Header = () => {
  const { data } = useSelector(state => state.wallet)
  const [isWrongNet, setIsWrongNet] = useState(false)
  const [show, setShow] = useState(false)
  const [showLangs, setShowLangs] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.tronWeb && window.tronWeb.defaultAddress.base58)
        new CoolCats().init(window.tronWeb)
          .then(c => c.getUserTokens(window.tronWeb.defaultAddress.base58))
          .then(() => {
            clearInterval(interval)
            setIsWrongNet(false)
          })
          .catch(e => {
            console.log(e)
            setIsWrongNet(true)
          })
    }, 500)

    return () => clearInterval(interval)
  }, [setIsWrongNet])

  const toggleMenu = () => {
    if (document.body.clientWidth <= 1100)
      document.body.className = show ? '' : 'menu-open'

    setShow(v => !v)
  }

  let langs = [
    {
      icon: <UK />,
      prefix: ''
    },
    {
      icon: <CN />,
      prefix: 'cn.'
    },
    {
      icon: <SK />,
      prefix: 'kr.'
    }
  ]
  let active = langs.splice(getPreffix(), 1)[0]

  return (
    <header className="page-header">
      <div className="content">
        <div className="socials">
          <span className="trx-label">
            {
              isWrongNet
              ? <span className="wrong">错误的网络</span>
              : data.balance || data.balance === 0
                ? `${ numSpaces(data.balance) } TRX`
                : 'connecting to wallet...'
            }
          </span>
          <div className="logo-container">
            <Tron />
          </div>
          <div className="divider"></div>
          <SocialLinks className="icon-link" />
        </div>
        <div className="main">
          <NavLink
            to="/"
            className="logo"
          >
            <Logo />
            <span className="title">
              <span className="text-red">TRON</span> 酷猫
            </span>
          </NavLink>
          <div className={cn( 'nav-container', { show } )}>
            <nav className="nav">
              <NavLink
                to="/gallery"
                className="nav-link"
                activeClassName="active"
                onClick={ toggleMenu }
              >
                照片
              </NavLink>
              <NavLink
                to="/market"
                className="nav-link"
                activeClassName="active"
                onClick={ toggleMenu }
              >
                市场
              </NavLink>
              <NavLink
                to="/wallet"
                className="nav-link"
                activeClassName="active"
                onClick={ toggleMenu }
              >
                我的钱包
              </NavLink>
              <NavLink
                to="/profile"
                className="nav-link"
                activeClassName="active"
                onClick={ toggleMenu }
              >
                简介
              </NavLink>
              <NavLink
                to="/mint"
                className="nav-button lead"
                activeClassName="active"
                onClick={ toggleMenu }
              >
                铸造一只猫
              </NavLink>
              <a
                className="nav-button"
                href="https://tronscan.org/#/contract/TAf4C5L5hXDh4o3ZufeUni4LEQbH1LHrz7"
                target="_blank"
                rel="noopener noreferrer"
              >
                合同
              </a>
              <div className={cn( 'lang-switcher', { show: showLangs } )}>
                <button
                  className="nav-button lang"
                  onClick={() => setShowLangs(v => !v)}
                >
                  { active.icon }
                </button>
                <div className="list-wrapper">
                  {
                    langs.map((item, i) => (
                      <a
                        key={ i }
                        className="nav-button lang"
                        href={`https://${ item.prefix }coolcatstron.com/`}
                      >
                        { item.icon }
                      </a>
                    ))
                  }
                </div>
              </div>
            </nav>
          </div>
          <button
            className={cn( 'burger-button', { show } )}
            onClick={ toggleMenu }
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      <div className="menu-bg"></div>
    </header>
  )
}